import { render, staticRenderFns } from "./subsidaries_active.vue?vue&type=template&id=20d11bdc&lang=pug"
import script from "./subsidaries_active.vue?vue&type=script&lang=js"
export * from "./subsidaries_active.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports